let isPopUpHidden = false;
document.addEventListener("DOMContentLoaded", () => {
  // const loadingMessage = document.getElementById('loading-message');
  const voteButtons = document.querySelectorAll(".vote-btn");
  voteButtons.forEach(button => {
    button.addEventListener("click", () =>{
      const emailInput = document.getElementById("user-email");
      const email = emailInput ? emailInput.value.trim() : null;
      
      console.log(email);
      const popup = document.getElementById('after-vote');
      const homeButton = popup.querySelector(".home-button");      
      
      if(email){
        const product = button.dataset.productId;
        console.log("votingGGGGg");
        popup.style.zIndex = '100';
        fetch(scriptURL, {
          method: 'POST',
          cache: "no-cache",
          headers: { "Content-Type": "text/plain;charset=utf-8" },
          body: JSON.stringify({
            type: "voteSubmission",
            email: email, // Send the email
            product: product // Send the selected product
          })
        })
        .then(response => response.json())
        .then(data => {
          if (data.status === "success") {
            console.log("Vote submitted successfully:");
            // loadingMessage.style.display = 'none';
            isPopUpHidden = true; 
            popup.querySelector("h3").textContent = "Thanks for voting!";
            popup.querySelector("p.voteRecorded").textContent = "感謝你的一票！你的投票結果已顯示在上方，來看看哪個顏色目前領先，也歡迎每天回來投票提供中獎率！";
            homeButton.style.display = 'inline-block';
          } else {
            alert(data.message || "Error submitting vote.");
          }
        })
        .catch(error => console.error("Error:", error));
      } else {
        alert("Email not found. Please enter your email first.");
      }     
   });
  });  
});